<div class="filters">

    <h2>Filtros de búsqueda</h2>

    <!-- Brand Filter Section -->
    <div class="brand-filter-container" *ngIf="brands && brands.length > 0">
      <h4>Marcas</h4>
      
      <!-- Brand search input (show when more than 10 brands) -->
      <div class="brand-search" *ngIf="brands.length > 10">
        <div class="search-input-wrapper">
          <span class="material-icons search-icon">search</span>
          <input 
            type="text" 
            [(ngModel)]="brandSearchText"
            (ngModelChange)="onBrandSearchChange()"
            placeholder="Buscar marca..."
            class="brand-search-input">
          <button *ngIf="brandSearchText" class="clear-search" (click)="clearBrandSearch()">
            <span class="material-icons">close</span>
          </button>
        </div>
      </div>

      <!-- Selected brands count -->
      <div class="selected-brands-info" *ngIf="selectedBrandIds.length > 0">
        <span class="selected-count">{{ selectedBrandIds.length }} marca{{ selectedBrandIds.length > 1 ? 's' : '' }} seleccionada{{ selectedBrandIds.length > 1 ? 's' : '' }}</span>
      </div>

      <div class="brand-list">
        <!-- Selected brands always show first -->
        <ng-container *ngIf="!brandSearchText && selectedBrandIds.length > 0">
          <div 
            class="brand-item active"
            *ngFor="let brand of getSelectedBrands()"
            (click)="onBrandClick(brand.id)">
            <mat-checkbox 
              [checked]="true" 
              (click)="$event.stopPropagation()"
              (change)="onBrandClick(brand.id)"
              color="primary">
            </mat-checkbox>
            <span class="brand-name">{{ brand.name }}</span>
            <span class="brand-count">({{ brand.count }})</span>
          </div>
          <div class="brand-separator" *ngIf="getUnselectedBrands().length > 0"></div>
        </ng-container>

        <!-- Unselected/filtered brands -->
        <div 
          class="brand-item" 
          *ngFor="let brand of getVisibleBrands()"
          [class.active]="isBrandSelected(brand.id)"
          (click)="onBrandClick(brand.id)">
          <mat-checkbox 
            [checked]="isBrandSelected(brand.id)" 
            (click)="$event.stopPropagation()"
            (change)="onBrandClick(brand.id)"
            color="primary">
          </mat-checkbox>
          <span class="brand-name">{{ brand.name }}</span>
          <span class="brand-count">({{ brand.count }})</span>
        </div>

        <!-- No results message -->
        <div class="no-brands-found" *ngIf="brandSearchText && getFilteredBrands().length === 0">
          No se encontraron marcas con "{{ brandSearchText }}"
        </div>
      </div>

      <!-- Show more/less button -->
      <button mat-button class="show-more-button" 
              *ngIf="!brandSearchText && getTotalUnselectedCount() > visibleBrandsLimit"
              (click)="toggleShowAllBrands()">
        <span class="material-icons">{{ showAllBrands ? 'expand_less' : 'expand_more' }}</span>
        {{ showAllBrands ? 'Ver menos' : 'Ver más (' + (getTotalUnselectedCount() - visibleBrandsLimit) + ' marcas más)' }}
      </button>

      <button mat-stroked-button (click)="clearBrandFilter()" class="reset-button" 
              *ngIf="isBrandFilterActive">
        ✕ Limpiar filtro de marca
      </button>
    </div>

    <h4>Precio</h4>
    
    <div class="price-filter-container">
      <!-- Price Range Display -->
      <div class="current-range" *ngIf="sliderMax > 0 && hasActiveFilter()">
        <span class="range-label">Rango seleccionado:</span>
        <div class="range-values">
          <span class="price-value">$ {{ minPrice | number:'1.0-0':'es-AR' }}</span>
          <span class="range-divider">—</span>
          <span class="price-value">$ {{ maxPrice | number:'1.0-0':'es-AR' }}</span>
        </div>
      </div>

      <!-- Price Range Inputs -->
      <div class="price-inputs">
        <div class="price-input-group">
          <label>Precio mínimo</label>
          <div class="input-wrapper">
            <span class="currency-symbol">$</span>
            <input 
              type="text" 
              [value]="minPriceInput !== null ? (minPriceInput | number:'1.0-0':'es-AR') : ''" 
              (blur)="onMinPriceInputBlur($event)"
              (keyup.enter)="onMinPriceInputBlur($event)"
              class="price-input"
              [placeholder]="brandMinPrice | number:'1.0-0':'es-AR'">
          </div>
        </div>
        
        <span class="price-separator">—</span>
        
        <div class="price-input-group">
          <label>Precio máximo</label>
          <div class="input-wrapper">
            <span class="currency-symbol">$</span>
            <input 
              type="text" 
              [value]="maxPriceInput !== null ? (maxPriceInput | number:'1.0-0':'es-AR') : ''" 
              (blur)="onMaxPriceInputBlur($event)"
              (keyup.enter)="onMaxPriceInputBlur($event)"
              class="price-input"
              [placeholder]="brandMaxPrice | number:'1.0-0':'es-AR'">
          </div>
        </div>
        
        <button mat-icon-button color="primary" (click)="applyPriceFilterNow()" class="apply-button" 
                [disabled]="!hasChanges()" 
                matTooltip="Aplicar filtro"
                aria-label="Aplicar filtro de precio">
          <span class="material-icons">arrow_forward</span>
        </button>
      </div>

      <!-- Dual Range Slider -->
      <div class="dual-range-container" *ngIf="sliderMax > 0">
        <div class="range-track">
          <div class="range-selected" [style.left]="getRangeLeft()" [style.width]="getRangeWidth()"></div>
        </div>
        <input 
          type="range"
          [min]="sliderMin"
          [max]="sliderMax"
          [step]="getSliderStep()"
          [value]="minPrice"
          (input)="onMinSliderInput($event)"
          class="range-slider range-min">
        <input 
          type="range"
          [min]="sliderMin"
          [max]="sliderMax"
          [step]="getSliderStep()"
          [value]="maxPrice"
          (input)="onMaxSliderInput($event)"
          class="range-slider range-max">
        
        <div class="slider-limits">
          <span class="limit-min">$ {{ sliderMin | number:'1.0-0':'es-AR' }}</span>
          <span class="limit-max">$ {{ sliderMax | number:'1.0-0':'es-AR' }}</span>
        </div>
      </div>

      <button mat-stroked-button (click)="resetPriceFilter()" class="reset-button" 
              *ngIf="isPriceFilterActive">
        ✕ Limpiar filtro de precio
      </button>
    </div>

    <br>
    <br>
    <mat-slide-toggle style="display:none;" labelPosition="before" [(ngModel)]="filterStock" (change)="onChangeFilterStock()">Con Stock</mat-slide-toggle>

</div>
